import React from 'react';
import styled from "styled-components"
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { BannerContainer } from "./style"
import Botao from "../../../components/Botao";


const ImagemEstilizada = styled.img`


  // Adicione mais estilos conforme necessário
  width: 600px;
  height: 350px;
  margin-left: 30px; 
  border: solid 2px red;
  //margin-top: -300px;

  @media (max-width: 768px) {
    width: 600px;
  height: 350px;
  margin-left: -85px; 
  }
`;

const BoxDiv = styled.div`


  // Adicione mais estilos conforme necessário
  width: 70%;
  color: white;
  max-width: 550;
  margin-top: -0px;
  //border: solid 2px red;

  @media (max-width: 768px) {
    width: 345px;
    margin-left: -30px;
    margin-top: -140px;
  color: white;
  max-width: 555;
  }

  @media (max-width: 375px) {
    width: 270px;
    margin-left: -70px;
    margin-top: -40px;
    font-size: 10px; 
  color: white;
  max-width: 555;
    
  }
`;

const BoxDivB = styled.div`


  // Adicione mais estilos conforme necessário
  width: 70%;
  align-items:center;
  margin-left: 40%;
  margin-top: 20px;

  @media (max-width: 768px) {
    margin-left: 20%;
  margin-top: 20px;
  }

  @media (max-width: 375px) {
    margin-left: 20%;
  margin-top: 20px;
    
  }
`;



const Banner = () => {

  const abrirWhatsApp = () => {
    const url = "https://api.whatsapp.com/send?phone=5511983267276&text=&source=&data=";
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <BannerContainer>
      <BoxDiv>
        <Typography variant="h3" gutterBottom>
          Soluções Jurídicas personalizadas
          esperam por você
        </Typography>
        <Typography variant="h6" gutterBottom>
          Você está em busca de orientação jurídica confiável? Deixe-nos ajudá-lo a navegar pelos complexos corredores da lei, identificando possíveis irregularidades jurídicas e resolvendo questões que podem afetar sua tranquilidade e segurança financeira.
        </Typography>
        <BoxDivB>
          <Botao
            texto='Seja Nosso Cliente'
            corFundo="#ff916e"
            corHover="#09af19"
            onClick={abrirWhatsApp}

          />
        </BoxDivB>
      </BoxDiv>



    </BannerContainer>
  );
};

export default Banner;